import React from "react";
import "./figure1.scss";

function Icon(props) {
  let dynamicStrokeClassName = () => {
    switch (props.color) {
      case "red":
        return "icon-stroke-red";
      case "orange":
        return "icon-stroke-orange";
      case "green":
        return "icon-stroke-green";
      case "white":
        return "icon-stroke-white";
      case "blue":
        return "icon-stroke-blue";
      case "blue-link":
        return "icon-stroke-blue-link";
      case "approved":
        return "icon-stroke-approved";
      default:
        return "icon-stroke-grey";
    }
  };
  let dynamicFillClassName = () => {
    switch (props.color) {
      case "red":
        return "icon-fill-red";
      case "orange":
        return "icon-fill-orange";
      case "green":
        return "icon-fill-green";
      case "grey":
        return "icon-fill-grey";
      case "blue":
        return "icon-fill-blue";
      case "blue-link":
        return "icon-fill-blue-link";
      case "white":
        return "icon-fill-white";
      case "approved":
        return "icon-fill-approved";
      default:
        return "icon-fill-grey";
    }
  };
  let dynamicSizeClassName = () => {
    switch (props.size) {
      case "small":
        return "icon-1";
      case "medium":
        return "icon-2";
      case "large":
        return "icon-3";
      case "extra-large":
        return "icon-4";
      default:
        return "icon-2";
    }
  };

  if (props.icon === "x-circle-outline") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 19 19"
        style={{ enableBackground: "new 0 0 19 19" }}
        className={`${dynamicSizeClassName()} ${props?.className}`}>
        <polygon
          points="9.4,10.9 6.3,14 5.3,12.9 8.4,9.9 5.3,6.8 6.3,5.8 9.4,8.8 12.5,5.8 13.5,6.8 10.4,9.9 13.5,12.9 12.5,14 "
          className={`${dynamicStrokeClassName()} ${dynamicFillClassName()}`}
        />
        <path
          d="M9.5,18.7c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2S14.6,18.7,9.5,18.7z M9.5,17c4.2,0,7.5-3.4,7.5-7.5S13.7,2,9.5,2S2,5.3,2,9.5S5.3,17,9.5,17z"
          className={`${dynamicStrokeClassName()} ${dynamicFillClassName()}`}
        />
      </svg>
    );
  } else if (props.icon === "times") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 19 19"
        style={{ enableBackground: "new 0 0 19 19" }}>
        <polygon
          className={`${dynamicFillClassName()}`}
          points="18.5,2 17.1,0.6 9.5,8.1 2,0.6 0.6,2 8.1,9.5 0.6,17.1 2,18.5 9.5,11 17.1,18.5 18.5,17.1 11,9.5 "
        />
      </svg>
    );
  } else if (props.icon === "checkmark-circle-outline") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 2 24 24"
        className={`${dynamicSizeClassName()} ${props?.className}`}>
        <path
          className={`${dynamicFillClassName()}`}
          d="M18.3,12.7l-6.6,6.6c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-4.6-4.6c-0.2-0.2-0.3-0.4-0.3-0.7 s0.1-0.5,0.3-0.7l1.6-1.6c0.2-0.2,0.4-0.3,0.7-0.3s0.5,0.1,0.7,0.3L11,14l4.3-4.3c0.2-0.2,0.4-0.3,0.7-0.3s0.5,0.1,0.7,0.3l1.6,1.6 c0.2,0.2,0.3,0.4,0.3,0.7S18.5,12.5,18.3,12.7z M20.5,14c0-1.5-0.4-3-1.1-4.3c-0.8-1.3-1.8-2.3-3.1-3.1C15,5.9,13.5,5.5,12,5.5 S9,5.9,7.7,6.6C6.4,7.4,5.4,8.4,4.6,9.7S3.5,12.5,3.5,14c0,1.5,0.4,3,1.1,4.3c0.8,1.3,1.8,2.3,3.1,3.1c1.3,0.8,2.7,1.1,4.3,1.1 s3-0.4,4.3-1.1c1.3-0.8,2.3-1.8,3.1-3.1C20.1,17,20.5,15.5,20.5,14z M24,14c0,2.2-0.5,4.2-1.6,6c-1.1,1.8-2.5,3.3-4.4,4.4 c-1.8,1.1-3.8,1.6-6,1.6s-4.2-0.5-6-1.6c-1.8-1.1-3.3-2.5-4.4-4.4C0.5,18.2,0,16.2,0,14s0.5-4.2,1.6-6S4.1,4.7,6,3.6 C7.8,2.5,9.8,2,12,2s4.2,0.5,6,1.6c1.8,1.1,3.3,2.5,4.4,4.4C23.5,9.8,24,11.8,24,14z"
        />
      </svg>
    );
  } else if (props.icon === "verified-checkmark") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 14 15"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        style={{ enableBackground: "new 0 0 14 15" }}>
        <polygon
          className={`${dynamicFillClassName()}`}
          points="5.4,14.2 0.8,9.7 2.2,8.2 5.1,11 11.9,0.4 13.6,1.5 "
        />
      </svg>
    );
  } else if (props.icon === "verified-checkmark-t15") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 10 11"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        style={{ enableBackground: "new 0 0 10 11" }}>
        <polygon
          className={`${dynamicFillClassName()}`}
          points="3.6,10.2 0.5,7 1.5,6 3.4,7.8 7.9,0.6 9.1,1.4 "
        />
      </svg>
    );
  } else if (props.icon === "exclamation") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 90 90"
        style={{ enableBackground: "new 0 0 90 90" }}>
        <rect
          className={`${dynamicFillClassName()}`}
          x="41.9"
          y="16.8"
          width="6.9"
          height="41.2"
        />
        <rect
          className={`${dynamicFillClassName()}`}
          x="41.9"
          y="63.3"
          width="6.9"
          height="9.2"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M45,89.7C20.3,89.7,0.3,69.7,0.3,45S20.3,0.3,45,0.3S89.7,20.3,89.7,45S69.7,89.7,45,89.7z M45,7.3 C24.2,7.3,7.3,24.2,7.3,45c0,20.8,16.9,37.7,37.7,37.7c20.8,0,37.7-16.9,37.7-37.7C82.7,24.2,65.8,7.3,45,7.3z"
        />
      </svg>
    );
  } else if (props.icon === "cme-clock") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 26 26">
        <g
          fill="none"
          fillRule="evenodd"
          className={`${dynamicStrokeClassName()}`}
          strokeWidth="1.927"
          transform="translate(1 1)">
          <path
            strokeLinecap="round"
            d="M11.11 15.424h7.174M11.077 5.824v9.6"
          />
          <circle cx="12" cy="12" r="12" />
        </g>
      </svg>
    );
  } else if (props.icon === "f1-logo") {
    return (
      <svg
        viewBox="0 0 22 22"
        version="1.1"
        className={`${dynamicSizeClassName()} ${props?.className}`}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-24.000000, -21.000000)"
            className={`${dynamicFillClassName()}`}>
            <g>
              <path d="M28,21 L42,21 C44.209139,21 46,22.790861 46,25 L46,39 C46,41.209139 44.209139,43 42,43 L28,43 C25.790861,43 24,41.209139 24,39 L24,25 C24,22.790861 25.790861,21 28,21 Z M29.0837205,32.916796 L29.7399867,32.916796 L29.7399867,36.2692885 L30.3804393,36.2692885 L30.3804393,32.9247028 L31.1394942,32.9247028 L31.1394942,32.3554116 L30.3804393,32.3554116 L30.3804393,31.8098409 C30.3804393,31.6358908 30.4199734,31.5251953 30.5069484,31.4619408 C30.5939235,31.406593 30.7125258,31.3749657 30.8706622,31.3749657 C30.92601,31.3749657 30.9892646,31.3749657 31.0525191,31.3828725 C31.1157737,31.3907794 31.1790283,31.3986862 31.234376,31.4224067 L31.234376,30.8610223 C31.1790283,30.8373018 31.1078669,30.8214882 31.0287987,30.8135814 C30.9497304,30.8056745 30.8864759,30.7977677 30.8232213,30.7977677 C30.4674143,30.7977677 30.1985824,30.8768359 30.0167255,31.0428792 C29.8348686,31.2010156 29.7399867,31.4461271 29.7399867,31.7624 L29.7399867,32.3475048 L29.0837205,32.3475048 L29.0837205,32.916796 Z M31.7483195,30.8531155 L31.7483195,31.6437977 L32.388772,31.6437977 L32.388772,30.8531155 L31.7483195,30.8531155 Z M31.7483195,32.3475048 L31.7483195,36.2613817 L32.388772,36.2613817 L32.388772,32.3475048 L31.7483195,32.3475048 Z M36.1761398,37.36043 C36.4686922,37.0441571 36.6189218,36.5618409 36.611015,35.9292952 L36.611015,32.3475048 L36.0021897,32.3475048 L36.0021897,32.9088892 L35.9942829,32.9088892 C35.8835874,32.6874982 35.7175441,32.5293617 35.5119667,32.4186662 C35.3063894,32.3079707 35.0770915,32.252623 34.83198,32.252623 C34.4919867,32.252623 34.2073411,32.3158775 33.9780433,32.4423867 C33.7408386,32.5688958 33.5589817,32.7349391 33.4166589,32.9326097 C33.2743361,33.1302802 33.1794542,33.3516712 33.1161997,33.5967827 C33.0608519,33.8418942 33.0292246,34.0790988 33.0292246,34.3083967 C33.0292246,34.5772286 33.0687587,34.8302469 33.1399201,35.0674516 C33.2189884,35.3046562 33.321777,35.5102336 33.4720067,35.6920905 C33.6222363,35.8739474 33.8040932,36.0162702 34.0175774,36.1190589 C34.2389684,36.2218476 34.4919867,36.2771953 34.7845391,36.2771953 C35.0296506,36.2771953 35.2747621,36.2139408 35.4961531,36.1032453 C35.7254509,35.9925498 35.8914942,35.8185997 36.0021897,35.5734882 L36.0180033,35.5734882 L36.0180033,35.8344133 C36.0180033,36.0558043 35.9942829,36.2534749 35.9547488,36.4353318 C35.9152146,36.6171887 35.8440532,36.7753251 35.7491714,36.9018343 C35.6542895,37.0283434 35.5277804,37.1311321 35.3854576,37.2022935 C35.235228,37.2734549 35.0612779,37.312989 34.8477937,37.312989 C34.745005,37.312989 34.6343095,37.3050822 34.5157072,37.2813617 C34.3971048,37.2576413 34.2864093,37.2181072 34.1915275,37.1706662 C34.0887388,37.1153185 34.0096705,37.0520639 33.9385092,36.9729957 C33.8673478,36.8939275 33.8357205,36.7990456 33.8278136,36.6804433 L33.1873611,36.6804433 C33.1952679,36.8939275 33.2506156,37.0678775 33.3534043,37.2181072 C33.4482862,37.36043 33.5827022,37.4790323 33.7329318,37.5739141 C33.8831614,37.668796 34.0571115,37.7320506 34.2468752,37.7715847 C34.4366389,37.8111188 34.6184958,37.8348393 34.8003527,37.8348393 C35.4249917,37.8348393 35.8835874,37.6767028 36.1761398,37.36043 Z M35.3538303,35.6051155 C35.2115075,35.6920905 35.0296506,35.7316246 34.8082596,35.7395314 C34.5947754,35.7395314 34.4208253,35.6920905 34.2785025,35.6051155 C34.1361797,35.5181404 34.0254842,35.3995381 33.9385092,35.2572153 C33.8515341,35.1148925 33.7882795,34.9488493 33.7566522,34.7748992 C33.7171181,34.6009491 33.7013045,34.4190922 33.7013045,34.2451421 C33.7013045,34.0553784 33.725025,33.8814283 33.7645591,33.7074782 C33.812,33.5414349 33.8752546,33.3912053 33.9701364,33.2567894 C34.0571115,33.1223734 34.1757138,33.0195847 34.3259434,32.9405165 C34.476173,32.8614483 34.6501231,32.8219141 34.8557005,32.8219141 C35.053371,32.8219141 35.2273211,32.8614483 35.3696439,32.9405165 C35.5119667,33.0274915 35.6305691,33.1302802 35.7175441,33.2646962 C35.8045191,33.3991121 35.8677737,33.5493418 35.9073078,33.715385 C35.9468419,33.8814283 35.9705624,34.0474715 35.9705624,34.2214216 C35.9705624,34.4032785 35.9468419,34.5851354 35.9073078,34.7669923 C35.8677737,34.9488493 35.7966123,35.1148925 35.7096373,35.2572153 C35.6226622,35.3995381 35.5040599,35.5181404 35.3538303,35.6051155 Z M38.5371168,36.497005 L38.5371168,36.5049118 L40.6561451,36.5049118 L40.6561451,26.0679068 L38.971992,26.0679068 C38.9166443,26.4632479 38.7901351,26.7953344 38.6003714,27.0641664 C38.4106077,27.3329983 38.1813098,27.5464825 37.904571,27.7125258 C37.6278323,27.8706622 37.3194662,27.9892646 36.9794729,28.0525191 C36.6315727,28.1157737 36.2757657,28.1394942 35.9120519,28.1315874 L35.9120519,29.7287654 L38.5371168,29.7287654 L38.5371168,36.497005 Z"></path>
            </g>
          </g>
        </g>
      </svg>
    );
  } else if (props.icon === "left-arrow") {
    return (
      <svg
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 18 16">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-40.000000, -24.000000)"
            className={`${dynamicFillClassName()}`}
            fillRule="nonzero">
            <g transform="translate(40.000000, 22.000000)">
              <g transform="translate(0.000000, 2.000000)">
                <polygon points="17.4328738 8.61538462 2.35592615 8.61538462 8.81748923 15.0770462 7.99988923 16 0 8 8.00001231 0 8.81748923 0.923089231 2.35595077 7.38461538 17.4328738 7.38461538"></polygon>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  } else if (props.icon === "chevron-down") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 13 8"
        enableBackground="new 0 0 13 8">
        <path d="M6.7,7.2l-6-6l0.9-0.9l5.1,5.1l5.1-5.1l0.9,0.9L6.7,7.2z" />
      </svg>
    );
  } else if (props.icon === "trash") {
    return (
      <svg
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 15 17"
        enableBackground="new 0 0 15 17">
        <path
          className={`${dynamicFillClassName()}`}
          d="M10,2V1H5v1H0v1h1v13c0,0.6,0.4,1,1,1h11c0.6,0,1-0.4,1-1V3h1V2H10z M2,16V3h11l0,13L2,16z"
        />
        <rect
          x="7"
          y="6"
          className={`${dynamicFillClassName()}`}
          width="1"
          height="7"
        />
        <rect
          x="10"
          y="6"
          className={`${dynamicFillClassName()}`}
          width="1"
          height="7"
        />
        <rect
          x="4"
          y="6"
          className={`${dynamicFillClassName()}`}
          width="1"
          height="7"
        />
      </svg>
    );
  } else if (props.icon === "chevron-left") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        className={`${dynamicStrokeClassName()} ${dynamicFillClassName()} ${dynamicSizeClassName()} ${
          props?.className
        }`}
        viewBox="0 0 17.24 28.83"
        enableBackground="new 0 0 12 20">
        <g className={`${dynamicStrokeClassName()} ${dynamicFillClassName()}`}>
          <polygon points="17.24 2.83 16.18 1.77 15.47 1.06 14.41 0 0 14.41 14.41 28.83 15.47 27.77 16.18 27.06 17.24 26 5.66 14.41 17.24 2.83" />
        </g>
      </svg>
    );
  } else if (props.icon === "chevron-right") {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        className={`${dynamicStrokeClassName()} ${dynamicFillClassName()} ${dynamicSizeClassName()} ${
          props?.className
        }`}
        viewBox="0 0 17.24 28.83"
        enableBackground="new 0 0 12 20">
        <g className={`${dynamicStrokeClassName()} ${dynamicFillClassName()}`}>
          <polygon points="2.83 0 1.77 1.06 1.06 1.77 0 2.83 11.59 14.41 0 26 1.06 27.06 1.77 27.77 2.83 28.83 17.24 14.41 2.83 0" />
        </g>
      </svg>
    );
  } else if (props.icon === "previous-slide-round") {
    // no fill or color rules for this file
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicStrokeClassName()} ${dynamicSizeClassName()} ${
          props?.className
        }`}
        viewBox="0 0 52 52">
        <g fill="none" fillRule="evenodd">
          <circle cx="26" cy="26" r="26" fill="#FFF" />
          <path strokeWidth="2.5" d="M33 13L20 26l13 13" />
        </g>
      </svg>
    );
  } else if (props.icon === "next-slide-round") {
    // no fill or color rules for this file
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicStrokeClassName()} ${dynamicSizeClassName()} ${
          props?.className
        }`}
        viewBox="0 0 52 52">
        <g fill="none" fillRule="evenodd">
          <circle cx="26" cy="26" r="26" fill="#FFF" />
          <path strokeWidth="2.5" d="M20 39l13-13-13-13" />
        </g>
      </svg>
    );
  } else if (props.icon === "close-button-x") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicFillClassName()} ${dynamicSizeClassName()} ${
          props?.className
        }`}
        viewBox="0 0 23 23">
        <g>
          <polygon points="0 20.59 9.12 11.45 0.05 2.41 2.46 0 11.53 9.04 20.55 0 22.95 2.41 13.93 11.45 23 20.59 20.59 23 11.53 13.86 2.4 23 0 20.59" />
        </g>
      </svg>
    );
  } else if (props.icon === "impact-factor-icon") {
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 12 12"
        space="preserve">
        <title>Impact Factor</title>
        <polygon fill="#40A5B6" points="0.2,5.8 6,0 6,5.8 6,11.7 " />
        <polygon fill="#2B7581" points="11.8,5.8 6,11.7 6,5.8 6,0 " />
      </svg>
    );
  } else if (props.icon === "user-verified-badge") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 11 12">
        <title>Verfified Badge</title>
        <path
          fill="#47606b"
          d="M9,0H2.2A2.23,2.23,0,0,0,0,2.24v6.5a1.62,1.62,0,0,0,.66,1.35l3.63,1.56a2.25,2.25,0,0,0,2.42,0l3.63-1.56A1.62,1.62,0,0,0,11,8.74V2.24A2.23,2.23,0,0,0,8.8,0"
        />
        <g>
          <polygon
            fill="#fff"
            points="5.03 8.76 2.63 6.2 3.37 5.52 4.97 7.24 8.61 2.69 9.39 3.31 5.03 8.76"
          />
        </g>
      </svg>
    );
  } else if (props.icon === "video-speaker-muted") {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 25 25">
        <title>MuteWhite</title>
        <rect
          className={`${dynamicFillClassName()}`}
          x="11.53"
          y="-3.78"
          width="2"
          height="32.53"
          transform="translate(30.23 12.45) rotate(135)"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M12.58,13.12v-.84s0,0,0,0c0-1.92,0-4.27,0-5.88a.91.91,0,0,0-1.46-.74L7.69,8.23Z"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M12.57,15.93,6.1,9.46l-.5.38a.72.72,0,0,1-.43.15H.76a.78.78,0,0,0-.73.82v5.35A.79.79,0,0,0,.76,17H5.17a.71.71,0,0,1,.43.14l5.5,4.23a.91.91,0,0,0,1.46-.74C12.56,19.33,12.56,17.57,12.57,15.93Z"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M16,15.87v.7l1.16,1.16A4.41,4.41,0,0,0,16,9.07v2a2.38,2.38,0,0,1,0,4.76Z"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M22.49,13.49a6.46,6.46,0,0,1-3.7,5.83l1.5,1.51A8.49,8.49,0,0,0,16,5V7A6.46,6.46,0,0,1,22.49,13.49Z"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M16.55,19.92c-.17,0-.34,0-.52,0v2a8.47,8.47,0,0,0,2.27-.32Z"
        />
      </svg>
    );
  } else if (props.icon === "video-speaker-non-muted") {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 25 25">
        <title>VolumeWhite</title>
        <path
          className={`${dynamicFillClassName()}`}
          d="M16,22V20A6.46,6.46,0,0,0,16,7V5a8.5,8.5,0,1,1,0,17Z"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M16,17.91v-2a2.38,2.38,0,0,0,0-4.76v-2a4.42,4.42,0,0,1,0,8.84Z"
        />
        <path
          className={`${dynamicFillClassName()}`}
          d="M12.58,14.69V12.28s0,0,0,0c0-1.92,0-4.27,0-5.88a.91.91,0,0,0-1.46-.74L5.6,9.84a.72.72,0,0,1-.43.15H.76a.78.78,0,0,0-.73.82v5.35A.79.79,0,0,0,.76,17H5.17a.71.71,0,0,1,.43.14l5.5,4.23a.91.91,0,0,0,1.46-.74c0-1.61,0-4,0-5.88C12.57,14.72,12.58,14.71,12.58,14.69Z"
        />
      </svg>
    );
  } else if (props.icon === "call-to-action") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${dynamicSizeClassName()} ${props?.className}`}
        viewBox="0 0 12 12">
        <path
          className={`${dynamicFillClassName()}`}
          d="M8.118 1.412a.706.706 0 0 1 0-1.412h3.176c.39 0 .706.316.706.706v3.177a.706.706 0 0 1-1.412 0V2.41L6.5 6.5a.706.706 0 0 1-.998-1l4.09-4.088H8.117zm2.47 5.294a.706.706 0 0 1 1.412 0v4.588c0 .39-.316.706-.706.706H.706A.706.706 0 0 1 0 11.294V.706C0 .316.316 0 .706 0h4.588a.706.706 0 0 1 0 1.412H1.412v9.176h9.176V6.706z"
        />
      </svg>
    );
  } else if (props.icon === "scroll-down-chevron") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="39"
        viewBox="0 0 72 39">
        <path
          className={`${dynamicFillClassName()}`}
          d="M53.185.49a2.75 2.75 0 0 1 3.13 4.521L28.75 24.095 1.185 5.011A2.75 2.75 0 1 1 4.315.49L28.75 17.406 53.185.489z"
        />
        <g
          className={`${dynamicFillClassName()}`}
          fillRule="nonzero"
          transform="translate(7.25 3.25)">
          <use fill="#FFF" fillOpacity=".999" />
        </g>
      </svg>
    );
  } else if (props.icon === "circle-star") {
    return (
      <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg">
        <g
          id="Verification"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd">
          <g id="drafts" transform="translate(-411.000000, -538.000000)">
            <g id="Group-21" transform="translate(395.500000, 210.452242)">
              <g id="Group-7" transform="translate(0.000000, 111.000000)">
                <g id="Group-37" transform="translate(16.000000, 216.962545)">
                  <g id="Group-28" className={`${dynamicFillClassName()}`}>
                    <ellipse
                      id="Oval"
                      cx="8.23900628"
                      cy="8.34705882"
                      rx="8.23900628"
                      ry="8.34705882"></ellipse>
                  </g>
                  <path
                    d="M7.95373653,3.66353537 L6.59965816,6.40576824 L6.59965816,6.40576824 L3.5739668,6.845184 C3.41000146,6.8689964 3.29638506,7.02122032 3.32019745,7.18518565 C3.32967583,7.25045106 3.36039632,7.31077454 3.40760668,7.35682446 L5.59668316,9.49209324 L5.59668316,9.49209324 L5.08014023,12.5052603 C5.05214539,12.6685636 5.16183452,12.8236413 5.32513777,12.8516361 C5.39012656,12.8627771 5.4569756,12.8521969 5.51534776,12.8215317 L8.22290816,11.3991432 L8.22290816,11.3991432 L10.9300766,12.8213258 C11.0767537,12.8983811 11.2581245,12.8419415 11.3351797,12.6952644 C11.3658726,12.6368397 11.3764434,12.5699244 11.3652548,12.5048835 L10.8469832,9.49209324 L10.8469832,9.49209324 L13.0369125,7.35686735 C13.155542,7.24120108 13.1579443,7.05126678 13.042278,6.93263721 C12.99622,6.88539926 12.9358747,6.85466146 12.8705838,6.84518219 L9.84400816,6.40576824 L9.84400816,6.40576824 L8.49179305,3.66367686 C8.41851378,3.51507738 8.2386455,3.45401828 8.09004601,3.52729756 C8.03086258,3.55648285 7.98295294,3.60436729 7.95373653,3.66353537 Z"
                    id="Fill-1"
                    fill="#FFFFFF"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        width="16px"
        height="16px"
        viewBox="0 0 21 21"
        style={{ enableBackground: "new 0 0 21 21" }}>
        <g transform="translate(15.000000, 541.000000)">
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <g>
                <path
                  d="M-4.5-520c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5C1.3-541,6-536.3,6-530.5 C6-524.7,1.3-520-4.5-520z M-4.5-539.5c-5,0-9,4.1-9,9s4.1,9,9,9s9-4.1,9-9S0.5-539.5-4.5-539.5z"
                  className={`${dynamicStrokeClassName()} ${dynamicFillClassName()}`}
                />
              </g>{" "}
            </g>{" "}
          </g>{" "}
        </g>
        <g>
          <path
            d="M10.5,4.4c2.2,0,3.7,1.3,3.7,3.1c0,1.3-0.6,2.2-1.7,2.8c-1.1,0.6-1.4,1.1-1.5,1.9V13H9v-0.9 c0-1.4,0.8-1.9,2-2.6c1-0.6,1.4-1.1,1.4-1.9c0-0.9-0.7-1.6-1.9-1.6c-1.1,0-1.9,0.7-2,2H6.8C6.9,5.8,8.1,4.4,10.5,4.4z M9.1,15.4 c0-0.8,0.5-1.3,1.3-1.3c0.8,0,1.3,0.5,1.3,1.3c0,0.8-0.5,1.3-1.3,1.3C9.6,16.6,9.1,16.1,9.1,15.4z"
            className={`${dynamicStrokeClassName()} ${dynamicFillClassName()}`}
          />
        </g>
      </svg>
    );
  }
}

export default Icon;
